import AddToCanvasModal from './AddToCanvasModal'
import EnterQueryString from './EnterQueryString'
import GenerateSearchReportModal from './GenerateSearchReportModal'
import MainMenu from './MainMenu'
import NewCanvasConfirmationModal from './NewCanvasConfirmationModal'
import NewSearchModal from './NewSearchModal'
import OpenSearchStrategyModal from './OpenSearchStrategyModal'
import SaveAsModal from './SaveAsModal'

export {
  AddToCanvasModal,
  EnterQueryString,
  GenerateSearchReportModal,
  MainMenu,
  NewCanvasConfirmationModal,
  NewSearchModal,
  OpenSearchStrategyModal,
  SaveAsModal
}



// WEBPACK FOOTER //
// ./src/components/mainMenu/index.js